import './Locations.css';

const Locations = () => {
  return (
    <section id="locations" className="section locations">
      <div className="container">
        <h2 className="section-title">Vehicle Locations</h2>
        
        <p className="locations-intro">We make it easy to get rolling:</p>

        <div className="locations-grid">
          <div className="location-card">
            <div className="location-icon">✈️</div>
            <h3>Airport Pickup</h3>
            <p>Reno RNO or Truckee/Tahoe airport pickup available</p>
          </div>

          <div className="location-card">
            <div className="location-icon">🚂</div>
            <h3>Train Station</h3>
            <p>Downtown Truckee / Amtrak Station pickup</p>
          </div>

          <div className="location-card">
            <div className="location-icon">🔑</div>
            <h3>Contactless</h3>
            <p>Key handoff via lockbox - no waiting in lines</p>
          </div>

          <div className="location-card">
            <div className="location-icon">🚗</div>
            <h3>Delivery Service</h3>
            <p>Delivery available (perfect for Truckee hotels & locals)</p>
          </div>

          <div className="location-card">
            <div className="location-icon">↔️</div>
            <h3>One Way Option</h3>
            <p>Pickup at RNO, return in Truckee/North Lake Tahoe or vice versa</p>
          </div>
        </div>

       
      </div>
    </section>
  );
};

export default Locations;
